import { Component } from '@angular/core';

@Component({
  selector: 'app-modal-outlet',
  templateUrl: './modal-outlet.component.html',
})
export class ModalOutletComponent {}
